import {Component, Input, OnInit} from '@angular/core';
import {DcpPriceServicePlanData} from '@app/model/price/dcp-price-service-plan-data';
import {DcpPriceIncludesData} from '@app/model/price/dcp-price-includes-data';
import {CheckmarkListEntry} from '@app/shared/checkmark-list/checkmark-list.component';
import {TranslationService} from '@spartacus/core';
import {combineLatest} from 'rxjs';
import {take} from 'rxjs/operators';
import {DcpPriceCommitmentPeriodData} from '@app/model/price/dcp-price-commitment-period-data';
import {DcpPriceRestrictionsData} from '@app/model/price/dcp-price-restrictions-data';
import {CurrentProductService} from '@spartacus/storefront';
import {TermsConditionsService} from '@app/services/terms-conditions.service';
import {DcpBundleTemplate} from '@dcp/configurator';
import {DcpProductUtilitiesService} from '../../../services/dcp-product-utilities.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'dcp-plans-and-pricing-features',
  templateUrl: './plans-and-pricing-features.component.html',
})
export class PlansAndPricingFeaturesComponent implements OnInit {

  @Input() servicePlan: DcpPriceServicePlanData;
  @Input() commitmentPeriod: DcpPriceCommitmentPeriodData;
  @Input() restrictions: DcpPriceRestrictionsData[];
  @Input() bundleTemplate: DcpBundleTemplate;
  @Input() hasContentForFeatureSection: boolean = false;
  includedList: CheckmarkListEntry[];
  termsConditionsProductEntries = [];

  constructor(
    private translationService: TranslationService,
    private currentProductService: CurrentProductService,
    private termsConditionsService: TermsConditionsService,
    private dcpProductUtilitiesService: DcpProductUtilitiesService,
  ) {
  }

  ngOnInit(): void {
    this.currentProductService.getProduct()
      .pipe(take(1), untilDestroyed(this))
      .subscribe((product) => {
        if (this.dcpProductUtilitiesService.isSapProduct(product)) {
          this.termsConditionsProductEntries = this.termsConditionsService.createTermsConditionsEntriesFromProduct(product, this.bundleTemplate?.id);
        }
      });
  }

  @Input() set includes(value: DcpPriceIncludesData[]) {
    if (value) {
      combineLatest([this.translationService.translate('productDetails.includes'), this.translationService.translate('productDetails.unlimited')])
        .pipe(take(1), untilDestroyed(this))
        .subscribe(([includes, unlimited]) => {
          this.includedList = value.map((entry) => ({
            value: includes + ' ' + (entry.unlimited ? unlimited : entry.amount) + ' ' + entry.metric.name,
          }));
        });
    } else {
      this.includedList = [];
    }
  }

  get durationTranslationKey(): string {
    if (this.commitmentPeriod.max) {
      if (this.commitmentPeriod.min) {
        return 'productDetails.minMaxDuration';
      }
      return 'productDetails.maxDuration';
    } else {
      return 'productDetails.minDuration';
    }
  }

  mergeArrays(array1: { name?: string; value: string }[], array2: { name?: string; value: string }[]) {
    if (array1 && array1.length) {
      if (array2 && array2.length) {
        return [...array1, ...array2];
      }
      return array1;
    }
    return array2;
  }

  onNoEntryData($event: any) {
    if (this.bundleTemplate?.id === $event.product?.id) {
      this.termsConditionsProductEntries = [];
    }
  }
}
